import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
  Tooltip
} from '@lockerpm/design';

import {
  KeyOutlined,
} from "@ant-design/icons";

import modalsComponents from "../../../../../components/modals";
import itemsComponents from "../../../../../components/items";
import securityModalsComponents from "./modals";

const ChangeMasterPassword = (props) => {
  const { PasswordConfirmModal } = modalsComponents;
  const { ChangeMasterPasswordModal } = securityModalsComponents;
  const { DocLink } = itemsComponents;
  const {
    className = '',
  } = props;
  const { t } = useTranslation();
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(null);

  const userInfo = useSelector(state => state.auth.userInfo);
  const isMobile = useSelector(state => state.system.isMobile);

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-semibold text-xl">
          {t('security.master_password.title')}
        </p>
        <Tooltip
          title={userInfo?.is_require_passwordless ? t('security.passwordless.require_passwordless') : ''}
        >
          <Button
            type='primary'
            ghost
            disabled={userInfo.is_require_passwordless}
            icon={<KeyOutlined />}
            onClick={() => setConfirmVisible(true)}
          >
            {isMobile ? '' : t('security.master_password.button')}
          </Button>
        </Tooltip>
      </div>
      <p className="mt-1">
        {t('security.master_password.description')}
      </p>
      <DocLink
        className="mt-2"
        title={t('security.master_password.doc')}
        docKey="WHAT_IS_MASTER_PASSWORD"
      />
      <PasswordConfirmModal
        visible={confirmVisible}
        title={t('security.master_password.button')}
        okText={t('button.confirm')}
        onConfirm={(password) => {
          setCurrentPassword(password);
          setConfirmVisible(false);
          setFormVisible(true)
        }}
        onClose={() => setConfirmVisible(false)}
      />
      <ChangeMasterPasswordModal
        visible={formVisible}
        currentPassword={currentPassword}
        onClose={() => setFormVisible(false)}
      />
    </div>
  );
}

export default ChangeMasterPassword;
